import { useContext } from "react";
import { SidebarCollapseContext } from "@/shared/ui/layout/sidebarCollapseContext";

export function useSidebarCollapse() {
  return useContext(SidebarCollapseContext);
}
